<template>
  <div>
    <input
      ref="input"
      v-bind="$attrs"
      :type="type"
      v-mask="mask"
      class="home-input"
      :class="[$attrs.class, { 'is-invalid': invalid }]"
      :placeholder="placeholder"
      :value="value"
      @input="onInput"
      @blur="onBlur"
      @keydown="$emit('keydown', $event)"
    />

    <div v-if="error" class="invalid-feedback">
      {{ error }}
    </div>
  </div>
</template>

<script>
export default {
  name: "Input",
  inheritAttrs: false,

  props: {
    mask: {
      type: Object,
      default: null,
    },
    value: {
      type: [String, Number],
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    error: {
      type: String,
      default: "",
    },
    invalid: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    onInput(event) {
      const inputValue = event.target.value;
      this.$emit("input", inputValue);

      if (this.mask && event.target.inputmask) {
        const isInvalid =
          !event.target.inputmask.isComplete() && inputValue !== "";
        this.$emit("invalid-mask", isInvalid);
      }
    },

    onBlur(event) {
      this.$emit("blur", event);

      if (this.mask && event.target.inputmask) {
        const isInvalid =
          !event.target.inputmask.isComplete() && event.target.value !== "";
        this.$emit("invalid-mask", isInvalid);
      }
    },
    focus() {
      this.$refs.input.focus();
    },
  },
};
</script>

<style scoped lang="less">
.home-input {
  width: 100%;
  height: 60px;
  border-radius: 10px;
  border: none;
  padding: 20px;
  font-family: Montserrat;
  font-weight: 500;
  font-style: Medium;
  font-size: 18px;
  line-height: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  outline: none;

  &:focus {
    outline: none;
    box-shadow: none;
  }

  &:focus-visible {
    outline: none;
    box-shadow: none;
  }
  &::placeholder {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  @media (max-width: 767px) {
    font-family: Montserrat;
    font-weight: 500;
    font-size: 16px;
  }
}
</style>
